import React, { useState, useRef } from 'react';

function VINInput({ onComplete, disabled }) {
    const [digits, setDigits] = useState(['', '', '', '', '', '']);
    const refs = useRef([]);

    const handleChange = (index, value) => {
        // Only allow numbers
        if (value && !/^\d$/.test(value)) return;
        
        const newDigits = [...digits];
        newDigits[index] = value;
        setDigits(newDigits);
        
        // Auto-focus next input
        if (value && index < 5) {
            refs.current[index + 1].focus();
        }
        
        // If all 6 digits entered, trigger verification
        if (index === 5 && value) {
            const vinNumber = newDigits.join('');
            onComplete(vinNumber);
        }
    };

    const handleKeyDown = (index, e) => {
        // Handle backspace to go to previous input
        if (e.key === 'Backspace' && !digits[index] && index > 0) {
            refs.current[index - 1].focus();
        }
    };

    const handlePaste = (e) => {
        e.preventDefault();
        const pastedData = e.clipboardData.getData('text').slice(0, 6);
        const newDigits = pastedData.split('').filter(char => /^\d$/.test(char));
        
        if (newDigits.length > 0) {
            const filledDigits = [...newDigits, ...Array(6 - newDigits.length).fill('')].slice(0, 6);
            setDigits(filledDigits);
            
            if (newDigits.length === 6) {
                onComplete(newDigits.join(''));
            } else if (newDigits.length < 6 && refs.current[newDigits.length]) {
                refs.current[newDigits.length].focus();
            }
        }
    };

    return (
        <div className="vin-input">
            <label>Enter the last 6 digits of your VIN</label>
            <div className="vin-digits">
                {digits.map((digit, i) => (
                    <input
                        key={i}
                        ref={el => refs.current[i] = el}
                        type="text"
                        inputMode="numeric"
                        maxLength="1"
                        value={digit}
                        onChange={(e) => handleChange(i, e.target.value)}
                        onKeyDown={(e) => handleKeyDown(i, e)}
                        onPaste={i === 0 ? handlePaste : undefined}
                        disabled={disabled}
                        className="vin-digit"
                    />
                ))}
            </div>
        </div>
    );
}

export default VINInput;